import { useCallback } from 'react'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { Description } from '@ui/sections/Description'

import { config } from './config'
import * as S from './styles'

export default function Ratings(props) {
  const { ids } = props
  const ratings = []

  const ratingsCallback = useCallback(
    ({ src, path, title, id: defaultId }) => {
      ids.forEach((id, index) => {
        if (defaultId === id) {
          ratings.push(
            <S.RatingLink key={id} href={path} order={index} target="blank">
              <S.WrapperImage className="image-wrapper">
                <ImageWithPlaceholder
                  fill
                  alt={title}
                  src={src}
                  sizes={100}
                  title={path ? `Go to ${path}` : title}
                />
              </S.WrapperImage>
              <S.SubTitle as="h3">{title}</S.SubTitle>
            </S.RatingLink>
          )
        }
      })
    },
    [ids]
  )

  const getRatings = () => {
    config.allRatings.forEach(ratingsCallback)

    return ratings
  }

  return (
    <S.RatingsSection>
      <Description {...props} />
      <S.Content className="content">{getRatings()}</S.Content>
    </S.RatingsSection>
  )
}
